import { useSelector } from 'react-redux';
import { EJsonQueryPriceType } from '../../../packages/api-models/common/json_query';
import { IApplicationState } from '../../types/redux';

export function usePriceTypeSelector() {
  return useSelector<IApplicationState, EJsonQueryPriceType | undefined>(
    state => state.filters.jsonQuery.price_type?.value,
  );
}
